import {Banner} from '@primer/react'
import {useCounts} from '../contexts/CountsContext'
import {useIsLoading} from '../contexts/IsLoadingContext'

export type DialogBannerProps = {
  errorMessage: string | null
}

export function DialogBanner({errorMessage}: DialogBannerProps) {
  const isLoading = useIsLoading()
  const {numberOfEnabledRulesets, numberOfEnabledPreviews} = useCounts()

  if (isLoading) {
    return null
  }

  if (errorMessage) {
    return (
      <Banner title="Error" hideTitle variant="critical">
        <Banner.Description>{errorMessage}</Banner.Description>
      </Banner>
    )
  }

  if (numberOfEnabledRulesets >= 75) {
    return (
      <Banner title="Too many rules selected" hideTitle variant="warning">
        <Banner.Description>Selected branch protections would generate more than 75 rulesets.</Banner.Description>
      </Banner>
    )
  }

  if (numberOfEnabledPreviews === 0) {
    return (
      <Banner title="No rules selected" hideTitle variant="warning">
        <Banner.Description>You must select at least one branch protection rule to import.</Banner.Description>
      </Banner>
    )
  }

  if (numberOfEnabledRulesets === 0) {
    return (
      <Banner title="No rules to create" hideTitle variant="warning">
        <Banner.Description>The current selection would not create any new rulesets.</Banner.Description>
      </Banner>
    )
  }

  return null
}
